// extracted by mini-css-extract-plugin
export default {"overlay":"Popup_overlay__Rlo3p","popup":"Popup_popup__DDMD3"};